// A brand illustration of one demand distributed between vans, not live data.
export default function BrandRoutes() {
  return <svg className="rf-brand-routes" viewBox="0 0 560 360" fill="none" aria-hidden="true" focusable="false">
    <defs>
      <pattern id="rf-route-grid" width="32" height="32" patternUnits="userSpaceOnUse"><circle cx="1" cy="1" r="1" fill="#41414a" /></pattern>
    </defs>
    <rect width="560" height="360" fill="url(#rf-route-grid)" />
    <g stroke="#34343d" strokeWidth="1.5">
      <path d="M0 80h240a40 40 0 0 1 40 40v160a40 40 0 0 0 40 40h240" />
      <path d="M80 0v110a40 40 0 0 0 40 40h320a40 40 0 0 1 40 40v170" />
      <path d="M0 280h140a40 40 0 0 0 40-40V50a40 40 0 0 1 40-40h340" />
      <path d="M350 0v150a30 30 0 0 0 30 30h180" />
    </g>
    <path className="rf-route-trace rf-route-trace-main" d="M80 245v-65a35 35 0 0 1 35-35h190a35 35 0 0 0 35-35V65" stroke="#f39a60" strokeWidth="3.5" strokeLinecap="round" pathLength="1" />
    <path className="rf-route-trace rf-route-trace-branch" d="M220 145h65a35 35 0 0 1 35 35v30a35 35 0 0 0 35 35h120" stroke="#f39a60" strokeWidth="3.5" strokeLinecap="round" pathLength="1" />
    <g fill="#141519" stroke="#f39a60" strokeWidth="3"><circle cx="80" cy="245" r="8"/><circle cx="340" cy="65" r="8"/><circle cx="475" cy="245" r="8"/></g>
    <rect x="205" y="130" width="30" height="30" rx="8" fill="#f39a60" />
    <path d="M214 145h12m-5-5 5 5-5 5" stroke="#251a14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <g fill="#b2b2bd" fontFamily="Inter, sans-serif" fontSize="12" fontWeight="500"><text x="55" y="279">Pedidos</text><text x="314" y="40">Van 01</text><text x="450" y="279">Van 02</text></g>
  </svg>;
}
